import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import * as Styled from 'sidePanel/styles/Tooltip.style';

interface TooltipProps {
  children: React.ReactNode;
  content: string;
  visible: boolean;
}

export default function Tooltip({
  children,
  content,
  visible,
}: TooltipProps): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (visible && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + rect.height / 2,
        left: rect.right + 12,
      });
    }
  }, [visible]);

  return (
    <>
      <Styled.TooltipContainer ref={containerRef}>
        {children}
      </Styled.TooltipContainer>
      {visible &&
        createPortal(
          <Styled.TooltipContent
            style={{
              top: `${position.top}px`,
              left: `${position.left}px`,
              position: 'fixed',
            }}
          >
            <Styled.TooltipArrow />
            <Styled.TooltipText>{content}</Styled.TooltipText>
          </Styled.TooltipContent>,
          document.body
        )}
    </>
  );
}
